export default "__VITE_ASSET__7a70f36d__"